export function metricAddToCart(item) {
	window.dataLayer.push({
		ecommerce: {
			currencyCode: "RUB",
			add: {
				products: [
					{
						id: item.carts[0].id,
						name: item.name_date,
						price: item.carts[0].price,
						brand: item.guest_team,
						list: item.tournament,
						variant: item.carts[0].name,
						category: item.sport_category,
					},
				],
			},
		},
	});
}

export function metricWatch(item) {
	window.dataLayer.push({
		"ecommerce": {
		  "currencyCode": "RUB",
		  "detail": {
			"products": [
			  {
				"id": item.id,
				"name" : item.name_date,
				'brand': item.guest_team,
				'list': item.nom,
				'category': item.category
			  }
			]
		  }
		}
	  });
}

export function metricRemoveFromCart(item) {
	window.dataLayer.push({
		ecommerce: {
			currencyCode: "RUB",
			remove: {
				products: [
					{
						id: item.carts[0].id,
						name: item.name_date,
						price: item.carts[0].price,
						brand: item.guest_team,
						list: item.tournament,
						variant: item.carts[0].name,
						category: item.sport_category
					},
				],
			},
		},
	});
}

export function metricPurchase(order, id) {
	const products = [];
	order.carts.forEach((item) => {
		products.push({
			id: item.id,
			name: item.name_date,
			price: item.price,
			discount: item.discount,
			brand: item.guest_team,
			list: item.tournament,
			variant: item.name,
			category: item.category,
		});
	});

	window.dataLayer.push({
		ecommerce: {
			currencyCode: "RUB",
			purchase: {
				actionField: {
					id: id,
					coupon: order.promocode,
				},
				products: products,
			},
		},
	});
}
